module.exports = __webpack_public_path__ + "img/template_grey.0bf1ed48.svg";